import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../api";
import { Card, Badge, Button, Toast, Loading, Empty, SectionHeader } from "../components/UI";
import { useNavigate } from "react-router-dom";


export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();


  useEffect(() => {
    API.get("/clients").then(r => setClients(r.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  const toggleActive = async (client) => {
    try {
      await API.put(`/client/${client._id}`, { isActive: !client.isActive });
      setClients(p => p.map(c => c._id === client._id ? { ...c, isActive: !c.isActive } : c));
      setToast({ message: `Client ${!client.isActive ? "activated" : "deactivated"}`, type: "success" });
    } catch { setToast({ message: "Update failed", type: "error" }); }
  };

  const deleteClient = async (id) => {
    if (!window.confirm("Delete this client?")) return;
    try {
      await API.delete(`/client/${id}`);
      setClients(p => p.filter(c => c._id !== id));
      setToast({ message: "Client deleted", type: "success" });
    } catch { setToast({ message: "Delete failed", type: "error" }); }
  };

  if (loading) return <Loading />;

  const th = { textAlign: "left", padding: "12px 16px", fontSize: 11, color: "var(--text-muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", background: "var(--bg-elevated)" };
  const td = { padding: "12px 16px", fontSize: 13, verticalAlign: "middle" };

  return (
    <div className="fade-in">
      <SectionHeader title="All Clients" subtitle={`${clients.length} dealership${clients.length !== 1 ? "s" : ""} registered`}
        action={<Link to="/app/add-client"><Button>⊕ Add Client</Button></Link>} />

      {clients.length === 0 ? <Card><Empty message="No clients yet." icon="◉" /></Card> : (
        <Card style={{ padding: 0, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr style={{ borderBottom: "1px solid var(--border)" }}>
              {["Dealership", "Brand", "City", "Credentials", "Sheet", "Status", "Actions"].map(h => <th key={h} style={th}>{h}</th>)}
            </tr></thead>
            <tbody>
              {clients.map((c, i) => (
                <tr key={c._id} style={{ borderBottom: "1px solid var(--border)", background: i % 2 === 0 ? "transparent" : "rgba(255,255,255,0.01)" }}>
                  <td style={td}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 30, height: 30, borderRadius: 7, background: "var(--bg-elevated)", border: "1px solid var(--border-light)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--font-mono)", fontWeight: 700, fontSize: 12, color: "var(--accent)" }}>{c.brand?.charAt(0)}</div>
                      <span style={{ fontWeight: 500 }}>{c.name}</span>
                    </div>
                  </td>
                  <td style={td}><Badge color="blue">{c.brand}</Badge></td>
                  <td style={{ ...td, color: "var(--text-secondary)" }}>{c.city || "—"}</td>
                  <td style={{ ...td, fontFamily: "var(--font-mono)", fontSize: 11 }}>
                    {c.whatsapp?.phoneId === "MOCK_PHONE_ID" ? <span style={{ color: "var(--accent-orange)" }}>MOCK</span> : <span style={{ color: "var(--accent)" }}>LIVE</span>}
                  </td>
                  <td style={{ ...td, fontSize: 11 }}>
                    {c.googleSheetUrl ? <span style={{ color: "var(--accent)" }}>✓ Connected</span> : <span style={{ color: "var(--text-muted)" }}>—</span>}
                  </td>
                  <td style={td}><Badge color={c.isActive ? "green" : "grey"}>{c.isActive ? "Active" : "Inactive"}</Badge></td>
                  <td style={td}>
                    <div style={{ display: "flex", gap: 6 }}>
                      <button onClick={() => toggleActive(c)} title={c.isActive ? "Deactivate" : "Activate"}
                        style={{ background: "var(--bg-elevated)", border: "1px solid var(--border)", borderRadius: 6, width: 28, height: 28, cursor: "pointer", fontSize: 12, color: "var(--text-secondary)" }}>
                        {c.isActive ? "⏸" : "▶"}
                      </button>
                      <button onClick={() => navigate(`/app/edit-client/${c._id}`)}
                      title="Edit"
                      style={{ background: "var(--bg-elevated)", border: "1px solid var(--border)", borderRadius: 6, width: 28, height: 28, cursor: "pointer", fontSize: 12, color: "var(--accent)" }}>
                        ✎
                      </button>
                      <button onClick={() => deleteClient(c._id)} title="Delete"
                        style={{ background: "var(--bg-elevated)", border: "1px solid var(--border)", borderRadius: 6, width: 28, height: 28, cursor: "pointer", fontSize: 12, color: "var(--accent-red)" }}>
                        ✕
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
}

